import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { environment } from "src/environments/environment";
import { VenueModel } from "../../models/venues/venue.model";
import { CreateOrEditCapacityModel } from "../../models/tables/create-or-edit-capacity.model";
import { DeleteGaleryImageModel } from "../../models/venues/delete-galery-image.model";
import { EditTableNameModel } from "../../models/tables/edit-table-name.model";


const VENUE_API = environment.apiURL + '/api/mng/Venue/';
const CAPACITY_API = environment.apiURL + '/api/mng/Capacity/'

@Injectable({
  providedIn: 'root'
})

export class VenueService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listvenues() {
    var url = VENUE_API + "listvenues";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  addvenue(model: VenueModel, file: any) {
    var url = VENUE_API + "addvenue";
    const formData: FormData = new FormData();
    formData.append('Name', model.name);
    formData.append('Address', model.address);
    formData.append('Phone', model.phone as string);
    formData.append('VenueImageLogo', file as string);
    if (model.description) {
      formData.append('Description', model.description);
    }
    if (model.userRules) {
      formData.append('UserRules', model.userRules);
    }
    if (model.latitude) {
      formData.append('Latitude', model.latitude.toString());
    }
    if (model.longitude) {
      formData.append('Longitude', model.longitude.toString());
    }
    if (model.venueImageGaleryPhotos) {
      for (let i = 0; i < model.venueImageGaleryPhotos.length; i++) {
        formData.append(`VenueImageGaleryPhotos`, model.venueImageGaleryPhotos[i] as string);
      }
    }
    if(model.venueWebsites){
      for (let i = 0; i < model.venueWebsites.length; i++) {
        formData.append(`WebSites`, model.venueWebsites[i] as string);
      }
    }

    if (model.capacityConfig) {
      formData.append('Capacity.IsDefault', model.capacityConfig.isDefault ? 'true' : 'false');
      if (model.capacityConfig.isDefault) {
        formData.append('Capacity.Name', 'Default capacity');
      } else {
        formData.append('Capacity.Name', model.capacityConfig.name);
        formData.append('Capacity.StartDate', model.capacityConfig.startDate);
        formData.append('Capacity.EndDate', model.capacityConfig.endDate);
        formData.append('Capacity.StartTime', model.capacityConfig.startTime);
        formData.append('Capacity.EndTime', model.capacityConfig.endTime);
      }

      formData.append('Capacity.Description', model.name);

      for (let i = 0; i < model.capacityConfig.capacityGroups.length; i++) {
        formData.append(`Capacity.CapacityGroups[][${i}][name]`, model.capacityConfig.capacityGroups[i].name);
        formData.append(`Capacity.CapacityGroups[][${i}][index]`, model.capacityConfig.capacityGroups[i].index.toString());
        for (let j = 0; j < model.capacityConfig.capacityGroups[i].capacityTables.length; j++) {
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].index`, model.capacityConfig.capacityGroups[i].capacityTables[j].index.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].xPosition`, model.capacityConfig.capacityGroups[i].capacityTables[j].xPosition.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].yPosition`, model.capacityConfig.capacityGroups[i].capacityTables[j].yPosition.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].numberOfPeople`, model.capacityConfig.capacityGroups[i].capacityTables[j].numberOfPeople.toString());
          formData.append(`Capacity.CapacityGroups[][${i}][capacityTables][][${j}].shape`, model.capacityConfig.capacityGroups[i].capacityTables[j].shape);
        }
      }
    }

    for (let i = 0; i < model.businessTypeIds.length; i++) {
      formData.append(`BusinessTypesIds[][${i}]`, model.businessTypeIds[i].toString());
    }

    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`)
      })
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updatevenue(model: VenueModel, file: any) {
    var url = VENUE_API + "updatevenue";
    const formData: FormData = new FormData();
    formData.append('Id', model.id);
    formData.append('Name', model.name);
    formData.append('Address', model.address);
    formData.append('Phone', model.phone as string);
    formData.append('VenueImageLogo', file as string);
    if (model.description) {
      formData.append('Description', model.description);
    }
    if (model.userRules) {
      formData.append('UserRules', model.userRules);
    }
    for (let i = 0; i < model.businessTypeIds.length; i++) {
      formData.append(`BusinessTypesIds[][${i}]`, model.businessTypeIds[i].toString());
    }
    if (model.venueImageGaleryPhotos) {
      for (let i = 0; i < model.venueImageGaleryPhotos.length; i++) {
        formData.append(`VenueImageGaleryPhotos`, model.venueImageGaleryPhotos[i] as string);
      }
    }
    if(model.venueWebsites){
      for (let i = 0; i < model.venueWebsites.length; i++) {
        formData.append(`WebSites`, model.venueWebsites[i] as string);
      }
    }
    if (model.latitude) {
      formData.append('Latitude', model.latitude.toString());
    }
    if (model.longitude) {
      formData.append('Longitude', model.longitude.toString());
    }
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("resy_access_token") as string}`)
      })
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updateCapacity(model: CreateOrEditCapacityModel) {
    var url = CAPACITY_API + "updatecapacity";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  editTableName(model: EditTableNameModel) {
    var url = CAPACITY_API + "updatetablename";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  createCapacity(model: CreateOrEditCapacityModel) {
    var url = CAPACITY_API + "createcapacity";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  viewVenueCapacity(venueId: string){
    var url = CAPACITY_API + "viewcapacity?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  deleteCapacityTemplate(id: string) {
    let url = CAPACITY_API + 'deletecapacity?CapacityTemplateId=' + id;
    return this._httpService.httpPost(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listCapacityTemplates(venueId: string) {
    let url = CAPACITY_API + "listcapacitytemplates?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  deletevenue(id: string) {
    var url = VENUE_API + 'deletevenue?venueId=' + id;
    return this._httpService.httpPost(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  getvenuedetails(id: string) {
    let url = VENUE_API + 'getvenuedetails?venueId=' + id;
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  getallbusinesstypes() {
    var url = VENUE_API + "getallbusinesstypes";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  deleteImagesFromVenueGalery(model: DeleteGaleryImageModel) {
    var url = VENUE_API + 'deleteimagesfromvenuegalery';
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  //#endregion
}
